<template>
  <div>
    <div class="decorative-divider"></div>

    <div class="text-center">
      <div class="card-surcharge">
        <p>Note: There is a card surcharge of {{ cardSurcharge|currency( booking.currency ) }}</p>
      </div>
      <div>
        <div class="stripe-payment">
          <div id="card-element" />
          <div id="cvc-element" />
          <div id="exp-element" />
        </div>
      </div>

      <div class="flex justify-center">
        <div v-if="errorMessage" style="background-color: #ffb3b7; padding-top: 0.5em; padding-bottom: 0.25em; margin-bottom: 0.5em; border-radius: 5%; width: 50%;">
          <p>
            <b>Error:</b>
            {{ errorMessage || 'Unknown Error' }}
          </p>
        </div>
      </div>

      <payment-pricing-table :booking="booking" :card-surcharge="cardSurcharge" :payment-amount="paymentAmount" ></payment-pricing-table>

      <ladda-button class="pin-payment-button btn btn-payment" :click="pay" aria-label="Pay Now">
        <i class="fa fa-lock"></i> Securely Pay Now
      </ladda-button>
      <div class="payment-icons">
        <img src="/static/visa.png" alt="Visa Card Logo"/>
        <img src="/static/mastercard.png" alt="MasterCard Logo"/>
        <img src="/static/amex.png" alt="Amex Logo"/>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import Selectize from '../ext/codium/CodiumSelectize'
import stripePayment from 'mixins/payments/stripePayment'
import { notify } from 'utils'
import LaddaButton from 'codium-ladda-button'
import PaymentPricingTable from './PaymentPricingTable'

export default {
  props: {
    paymentIds: {
      required: true,
      type: Array
    },
    paymentAmount: {
      required: true,
      type: Number
    },
    cardSurcharge: {
      default: 0,
      required: true,
      type: Number
    }
  },

  data () {
    return {
      stripe: false,
      cardNumber: false,
      cardExpiry: false,
      cardCvc: false
    }
  },

  mixins: [stripePayment],

  created () {
    this.setupStripe(this.booking.region.shortname).then(() => {
      this.populateFields()
    })
  },

  components: {
    Selectize,
    LaddaButton,
    PaymentPricingTable
  },

  computed: {
    ...mapState('payment', ['clientToken']),
    ...mapState('booking', ['booking'])

  },

  methods: {
    pay () {
      return this.paymentIntent(this.paymentIds, (response) => {
        notify.success('Payment received')
        this.$router.go()
        return Promise.resolve()
      }, (response) => {
        notify.error('We encountered a server error, you have not been charged,  please try again later.')
        return Promise.reject(new Error('We encountered a server error, you have not been charged,  please try again later.'))
      })
    }
  }
}
</script>

<style>
.StripeElement {
  box-sizing: border-box;
  height: 40px;
  padding: 10px 12px;
  border: 2px solid black;
  border-radius: 0;
  background-color: white;
  box-shadow: 0 1px 3px 0 #e6ebf1;
  transition: box-shadow 150ms ease;
  margin: 20px 0;
  color:#555;
  font-family: inherit;
}

.StripeElement--focus {
  box-shadow: 0 1px 3px 0 #cfd7df;
}

.StripeElement--invalid {
  border-color: #fa755a;
}

.StripeElement--webkit-autofill {
  background-color: #fefde5 !important;
}
</style>
